import React, {useState} from 'react';
import AppleCategorySelector from "../../../../services/categories/AppleCategorySelector";

function BulkLocationEditorApple ({locationPatch, mergeIntoLocationPatch, appleCategoriesStore, updateAppleCategories, updatePrimaryAppleCategory}) {

    const [appleCategoriesErrorMessage, setAppleCategoriesErrorMessage] = useState(null);

    const handleAppleCategoriesUpdate = (selected) => {
        if (selected.length <= 5) {
            updateAppleCategories(selected);
            setAppleCategoriesErrorMessage(null)
        } else {
            setAppleCategoriesErrorMessage("Select up to 5 Apple categories.")
        }
    };

    const setTrackingUrl = (e) => {
        const trackingUrl = e.target.value;
        mergeIntoLocationPatch({
            "listingManagementSpecs": {
                "providerTrackingWebsiteUrls": {
                    "APPLE": trackingUrl
                }
            }
        })
    };

    const maybeLatitude = !!locationPatch.listingManagementSpecs
      && !!locationPatch.listingManagementSpecs.appleCoordinates
      && !!locationPatch.listingManagementSpecs.appleCoordinates.appleLat
      && locationPatch.listingManagementSpecs.appleCoordinates.appleLat;

    const maybeLongitude = !!locationPatch.listingManagementSpecs
      && !!locationPatch.listingManagementSpecs.appleCoordinates
      && !!locationPatch.listingManagementSpecs.appleCoordinates
      && locationPatch.listingManagementSpecs.appleCoordinates.appleLng;

    return <div className="card-spacer-top card-spacer-bottom">
        <h5>Apple Category</h5>
        <div className="row card-spacer-top">
            <div className="col-12 col-sm-12">
                <AppleCategorySelector
                    multi={false}
                    selected={!!locationPatch.listingManagementSpecs.primaryAppleCategory ? [locationPatch.listingManagementSpecs.primaryAppleCategory] : []}
                    appleCategoriesStore={appleCategoriesStore}
                    onSelect={updatePrimaryAppleCategory}
                />
            </div>
        </div>

        <h5 className="card-spacer-top">Additional Apple Categories</h5>
        <div className="row card-spacer-top">
            <div className="col-12 col-sm-12">
                <AppleCategorySelector
                    multi={true}
                    selected={locationPatch.listingManagementSpecs.appleCategories}
                    appleCategoriesStore={appleCategoriesStore}
                    onSelect={handleAppleCategoriesUpdate}
                />
                {appleCategoriesErrorMessage ? <div className="invalid-feedback" style={{"display": "block"}}>{appleCategoriesErrorMessage}</div> : <div className="invalid-feedback" style={{"opacity": "0", "display": "block"}}>line spacer</div>}
            </div>
        </div>

        <h5 className="card-spacer-top">Apple Coordinates</h5>
        <div className="row card-spacer-top">
            <div className="col-12">
                <label>Latitude <input
                  disabled={true}
                  type="text"
                  id="appleCoordinatesLat"
                  placeholder="Latitude"
                  maxLength={10}
                  value={maybeLatitude || ''}
                  // onChange={setAppointmentUrl} TODO
                  className="form-control text-input"
                /></label>
            </div>
        </div>
        <div className="row card-spacer-top">
            <div className="col-12">
                <label>Longitude <input
                  disabled={true}
                  type="text"
                  id="appleCoordinatesLng"
                  placeholder="Longitude"
                  maxLength={10}
                  value={maybeLongitude || ''}
                  // onChange={setAppointmentUrl} TODO
                  className="form-control text-input"
                /></label>
            </div>
        </div>

    </div>
}

export default BulkLocationEditorApple;